/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Metabolic Control Diabetes View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './MetabolicControlDiabetesView';

export const mapStateToPropsMetabolicControlDiabetes = mapStateToProps;
export const mapDispatchToPropsMetabolicControlDiabetes = mapDispatchToProps;

export default connect(
  mapStateToPropsMetabolicControlDiabetes,
  mapDispatchToPropsMetabolicControlDiabetes
)(View);
